<script lang="ts" setup>
import { computed } from "vue";
import type { PropType } from "vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import { Application } from "@/types/order/Application";
import {
  formatFromISOString,
} from "@/utils/date";

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  application: {
    type: Object as PropType<Application>,
    required: true
  }
});

const contactLink = process.env.VUE_APP_URL_CONTACT;

const attendanceCorrectionRoute = computed(() => ({
  name: "AttendanceCorrection",
  params: {
    applicationId: props.application.id.toString()
  }
}));

const displayScheduledWorkDate = computed(() => {
  return `${formatFromISOString(
    props.application.appliedStartWorkAt,
    "MM/dd(E)"
  )}`;
});

const displayScheduledWorkTime = computed(() => {
  return `${formatFromISOString(
    props.application.appliedStartWorkAt,
    "HH:mm"
  )}-${formatFromISOString(props.application.appliedFinishWorkAt, "HH:mm")}（${
    props.application.appliedHasRest
      ? `${formatFromISOString(
        props.application.appliedStartRestAt,
          "HH:mm"
        )}-${formatFromISOString(props.application.appliedFinishRestAt, "HH:mm")}`
      : "休憩なし"
  }）`;
});
</script>

<template>
  <BModal
    :visible="visible"
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    centered
  >
    <div class="px-2 pb-2">
      <p>未出勤のお仕事があります！</p>
      <p>
        出退勤を忘れていた場合、早急に勤怠変更申請を行ってください
      </p>
      <div class="my-3">
        <table class="w-100">
          <colgroup>
            <col class="label-cell" />
            <col />
          </colgroup>
          <tr>
            <td>勤務日</td>
            <td>{{ displayScheduledWorkDate }}</td>
          </tr>
          <tr>
            <td>定刻（休憩）</td>
            <td>{{ displayScheduledWorkTime }}</td>
          </tr>
        </table>
      </div>
      <AppButton block class="mb-3 mt-1" :to="attendanceCorrectionRoute">
        勤怠変更申請する
      </AppButton>
      <p class="font-weight-bold">キャンセルの場合</p>
      <p>運営事務局へお問い合わせください</p>
      <AppButtonOutline
        :href="contactLink"
        size="small"
        block
        class="mb-3 mt-1"
      >
        お問い合わせフォーム
      </AppButtonOutline>
      <p>
        お仕事終了日から1週間ご連絡がない場合、一時的にアカウントが利用停止となります
      </p>
    </div>
  </BModal>
</template>

<style lang="scss" scoped>
.label-cell {
  width: 100px;
}
</style>
